<template>
  <div class="form-group" :style="{'width': fieldWidth}">
    <ValidationProvider :rules="rule" :name="fieldName" v-slot="{ errors }" ref="formInput">
      <h3 v-if="!!fieldTitle" class="form-input-title">
        {{fieldTitle}}
      </h3>
      <label :for="fieldName" class="label-field">
        <input
          :type="type"
          class="form-input"
          :class="{ 'field-error text-input-error': getFieldError(errors)}"
          :id="`${fieldName}-${_uid}`"
          :name="fieldName"
          :placeholder="placeholder"
          v-model="input"/>
      </label>
      <div v-show="getFieldError(errors)" class="text-error-field">{{ errors[0]}}</div>
    </ValidationProvider>
  </div>
</template>

<script>
  // import {SET_FORM_DATA} from '../../store/mutations'

  import {SET_FORM_DATA} from "@/store/mutations";

  export default {
    name: 'InputField',
    props: {
      // required
      fieldTitle: {
        required: true
      },
      fieldName: {
        required: true
      },
      type: {
        required: true
      },
      placeholder: {
        required: true
      },
      // not required
      value: {
        required: false
      },
      rule: {
        required: false,
        // default: 'required'
      },
      fieldWidth: {
        default: '100%'
      },
      groupIndex: {
        required: false
      },
      groupName: {
        required: false
      },
      callback: {
        required: false
      },
      debounce: {
        type: Number,
        required: false,
        default: 500
      },
      clearField: {
        type: Boolean,
        required: false
      },
      registerError: {
        type: Boolean,
        required: false,
        default: false
      },
      registerErrorText: {
        type: String,
        required: false,
      }
    },
    data: () => ({
      input: '',
      timeOut: undefined,
    }),
    computed: {
      // authError: function () {
      //   return this.$store.getters.getAuthError;
      // },
    },
    methods: {
      setInputTimeout: function () {
        clearTimeout(this.timeOut)
        this.timeOut = setTimeout(() => {
          this.setFormData()
        }, this.debounce)
      },
      // send the form data to the store
      setFormData: function () {
        let data = {fieldName: this.$props.fieldName, data: this.input}
        // if it's a group value, we need to send the value with index (id in form data) and field name
        if (this.$props.groupIndex) {
          data.groupIndex = this.$props.groupIndex
          data.groupName = this.$props.groupName
          // add field name, the name is name-{index}, so get the first value from array
          let name = this.$props.fieldName
          data.fieldName = name.split('-')[0]
        }
        this.$store.commit(SET_FORM_DATA, data);
      },
      getFieldError: function (errors) {
        return this.registerError || errors[0];
      }
    },
    created() {
      if (this.$props.value) {
        this.input = this.$props.value
      }
    },
    watch: {
      input: function () {
        this.setInputTimeout()
      },
      clearField: function (newValue) {
        if (newValue) {
          this.input = '';
          this.$refs.formInput.reset();
        }
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
